import { render, staticRenderFns } from "./PublicationStats.vue?vue&type=template&id=26069dd5&"
import script from "./PublicationStats.vue?vue&type=script&lang=js&"
export * from "./PublicationStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports